import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { registerDTLayer } from './datalayerEvent'

const bootstrapReactComponents = (): void => {
  // Locate all potential dtc-react-component nodes to render components in.
  const contextRoot = ReactDOM.createRoot(document.createElement('dtc-react-root'))

  contextRoot.render(<App />)
}

const waitForDrupalSettings = (callback: () => void): void => {
  callback()
}

waitForDrupalSettings(() => {
  if (document.readyState.length > 0) {
    setTimeout(() => {
      bootstrapReactComponents()
      registerDTLayer()
    }, 1000)
  } else {
    // Given the need to wait for drupalSettings, this case may not be needed anymore
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        bootstrapReactComponents()
        registerDTLayer()
      }, 1000)
    })
  }
})
